import React from "react";
import SectionTitle from "./SectionTitle";
import { KeyMetrics } from "./analytics/KeyMetrics";
import { Container, Row } from "react-bootstrap";
import WorldMapHeatMap from "./analytics/WorldMapHeatMap";
import LatestRansomware from "./analytics/LatestRansomware";
import TopGroups from "./analytics/TopGroups";
import TopSectors from "./analytics/TopSectors";
import RansomwareOverTimeChart from "./analytics/RansomwareOverTimeChart";
import moment from "moment";
import RansomwareDropdownFilter from "./filters/RansomwareDropdownFilter";

const RansomwareSection = ({
  ransomwareDates,
  topGroupNames,
  topSectors,
  countrieFilter,
  setCountrieFilter,
  sectorFilter,
  setSectorFilter,
  groupFilter,
  setGroupFilter,
  countries,
  sectors,
  groups,
  dateOptions,
  selectedOption,
  handleChange,
  queryParam,
}) => {
  return (
    <div>
      <SectionTitle
        title={"The Evolving Threat of Ransomware"}
        question={`How do you know you are not next?`}
        description={`Lumu actively monitors Ransomware groups to gain tactical 
              intelligence and uses this intelligence to protect its customers against this evolving and disrupting threat. 
              Gain a strategic edge with Lumu's vigilant analysis of global ransomware 
              trends`}
        date={`since ${moment(ransomwareDates).format("MMM YYYY")}.`}
      />
      <RansomwareDropdownFilter
        countrieFilter={countrieFilter}
        setCountrieFilter={setCountrieFilter}
        sectorFilter={sectorFilter}
        setSectorFilter={setSectorFilter}
        groupFilter={groupFilter}
        setGroupFilter={setGroupFilter}
        countries={countries}
        sectors={sectors}
        groups={groups}
        dateOptions={dateOptions}
        selectedOption={selectedOption}
        handleChange={handleChange}
      />
      <KeyMetrics queryParam={queryParam} />
      <Container fluid>
        <Row>
          <WorldMapHeatMap queryParam={queryParam} />
          <RansomwareOverTimeChart queryParam={queryParam} selectedOption={selectedOption} />
          <TopGroups data={topGroupNames} />
          <TopSectors data={topSectors} />
          <LatestRansomware queryParam={queryParam} />
        </Row>
      </Container>
    </div>
  );
};

export default RansomwareSection;
